import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { messages } from './IdealLanding.messages';
export var IdealLanding =
/*#__PURE__*/
function (_Component) {
  _inherits(IdealLanding, _Component);

  function IdealLanding() {
    _classCallCheck(this, IdealLanding);

    return _possibleConstructorReturn(this, _getPrototypeOf(IdealLanding).apply(this, arguments));
  }

  _createClass(IdealLanding, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.startPollingForSubscription();
    }
  }, {
    key: "render",
    value: function render() {
      var intl = this.props.intl;
      return React.createElement("div", {
        className: "checkout__landing"
      }, React.createElement(Helmet, null, React.createElement("title", null, intl.formatMessage(messages.pageTitle)), React.createElement("meta", {
        property: "og:title",
        content: intl.formatMessage(messages.pageTitle)
      })), React.createElement("div", {
        className: "checkout__landing__content"
      }, React.createElement("h1", {
        className: "checkout__landing__title gamma proxima mt mb+"
      }, React.createElement(FormattedMessage, messages.title)), React.createElement("p", {
        className: "checkout__landing__subtitle"
      }, React.createElement(FormattedMessage, messages.subtitle)), React.createElement("p", null, React.createElement(FormattedMessage, messages.questions), React.createElement(Link, {
        className: "checkout__landing__contact-us",
        to: "/contact",
        target: "_blank",
        rel: "noopener noreferrer"
      }, React.createElement(FormattedMessage, messages.contactSupport)))));
    }
  }]);

  return IdealLanding;
}(Component);
IdealLanding.propTypes = {
  intl: intlShape.isRequired,
  startPollingForSubscription: PropTypes.func.isRequired
};